import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
  canSave: boolean;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onClose,
  onSave,
  onDiscard,
  canSave,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="unsaved-changes-dialog-title">
        {t('unsavedChangesDialog.title', 'Unsaved Changes')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          {t(
            'unsavedChangesDialog.message',
            'You have unsaved changes. What would you like to do?',
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('unsavedChangesDialog.cancel', 'Cancel')}
        </Button>
        <Button onClick={onDiscard} color="inherit">
          {t('unsavedChangesDialog.discard', 'Discard Changes')}
        </Button>
        {canSave && (
          <Button onClick={onSave} color="primary" variant="contained">
            {t('unsavedChangesDialog.save', 'Save Changes')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
